export default __webpack_public_path__ + "static/media/header_shelf_xs.d5fcdf77.webp";